import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AppSettingsProvider } from "@/contexts/AppSettingsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import LeadsPage from "@/pages/LeadsPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";
import ApplyPage from "@/pages/ApplyPage";
import ServiceComplaintPage from "@/pages/ServiceComplaintPage";
import DataRecordsPage from "@/pages/DataRecordsPage";
import OnlineUsersPage from "@/pages/OnlineUsersPage";
import TicketsPage from "@/pages/TicketsPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App dark">
      <AppSettingsProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/layanandankeluhan" element={<ServiceComplaintPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<DashboardPage />} />
              <Route path="/leads" element={<LeadsPage />} />
              <Route
                path="/tickets"
                element={
                  <ProtectedRoute roles={["super_admin", "direktur", "manager", "admin"]}>
                    <TicketsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute roles={["super_admin"]}>
                    <UsersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute roles={["super_admin"]}>
                    <SettingsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/records"
                element={
                  <ProtectedRoute roles={["super_admin", "direktur"]}>
                    <DataRecordsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/online-users"
                element={
                  <ProtectedRoute roles={["super_admin", "direktur", "manager"]}>
                    <OnlineUsersPage />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors theme="dark" position="bottom-right" />
      </AuthProvider>
      </AppSettingsProvider>
    </div>
  );
}

export default App;
